export type HomeMainTab = 'discover' | 'live'

const HOME_MAIN_TAB_STORAGE_KEY = 'pumpkin_home_main_tab'

const HOME_MAIN_TAB_PATH: Record<HomeMainTab, string> = {
  discover: '/',
  live: '/live',
}

function getStoredValue() {
  if (typeof window === 'undefined') return null

  return window.localStorage.getItem(HOME_MAIN_TAB_STORAGE_KEY)
}

export function setStoredHomeMainTab(tab: HomeMainTab) {
  if (typeof window === 'undefined') return

  window.localStorage.setItem(HOME_MAIN_TAB_STORAGE_KEY, tab)
}

export function hasStoredHomeMainTab() {
  return getStoredValue() === 'discover' || getStoredValue() === 'live'
}

export function getStoredHomeMainTab(): HomeMainTab {
  return getStoredValue() === 'live' ? 'live' : 'discover'
}

export function getStoredHomeMainTabPath() {
  return HOME_MAIN_TAB_PATH[getStoredHomeMainTab()]
}
